"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribe = exports.getSubscriptions = exports.getSubscription = void 0;
const Sessions = require("./Sessions");
/**
 * Purpose unknown
 *
 * @param semotus
 * @param {unknown} subscriptionId unknown
 *
 * @returns {unknown} unknown
 *
 * @private
 */
function getSubscription(semotus, subscriptionId) {
    return Sessions.get(semotus).subscriptions[subscriptionId || 0];
}
exports.getSubscription = getSubscription;
/**
 * Purpose unknown
 *
 * @param semotus
 * @param {unknown} sessionId unknown
 *
 * @returns {unknown} unknown
 *
 * @private
 */
function getSubscriptions(semotus, sessionId) {
    const session = Sessions.get(semotus, sessionId);
    if (session) {
        return session.subscriptions;
    }
    else {
        return null;
    }
}
exports.getSubscriptions = getSubscriptions;
/**
 * Subscribe to changes and optionally establish subscription as the
 * sole recipient of remote call messages.  Change tracking is then managed
 * by the functions that follow.
 *
 * @param semotus
 * @param {unknown} role unknown
 *
 * @returns {*} unknown
 */
function subscribe(semotus, role) {
    const session = Sessions.get(semotus);
    const subscriptionId = session.nextSubscriptionId++;
    session.subscriptions[subscriptionId] = {
        role: role,
        log: {
            array: {},
            change: {},
            arrayDirty: {}
        }
    };
    return subscriptionId;
}
exports.subscribe = subscribe;
//# sourceMappingURL=data:application/json;base64,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